const linkHoverStyles = {
  marginTop: '1px',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'green.600'
};

export default linkHoverStyles;